import type { ChatMessages } from "@storytell/cp-client";
import type { CitationNodeProps } from "@storytell/rich-text";
import { type Component, Match, Switch } from "solid-js";
import type { WebSearchResultsCollection } from "~/utils/citationResolver";
import { getCitationType } from "~/utils/citationUtils";
import { ArtifactCitationRenderer } from "./ArtifactCitationRenderer";
import { WebCitationRenderer } from "./WebCitationRenderer";

export interface UnifiedCitationRendererProps {
  node: { attrs: { value: string } };
  selected?: boolean;
  webSearchResults?: WebSearchResultsCollection;
}

/**
 * Unified citation renderer that detects citation type and delegates to
 * the appropriate renderer (ArtifactCitationRenderer for assets or WebCitationRenderer for web)
 */
export const UnifiedCitationRenderer: Component<UnifiedCitationRendererProps> = (props) => {
  const citationType = () => getCitationType(props.node.attrs.value);

  return (
    <Switch fallback={<span class="text-muted-text">[{props.node.attrs.value}]</span>}>
      <Match when={citationType() === "asset"}>
        {/* ArtifactCitationRenderer expects CitationNodeProps, so we cast our simplified props */}
        <ArtifactCitationRenderer {...(props as unknown as CitationNodeProps)} />
      </Match>
      <Match when={citationType() === "web"}>
        <WebCitationRenderer node={props.node} selected={props.selected} webSearchResults={props.webSearchResults} />
      </Match>
    </Switch>
  );
};
